import { render, staticRenderFns } from "./BornTodayUsers.vue?vue&type=template&id=0ad2fa5e&"
import script from "./BornTodayUsers.vue?vue&type=script&lang=js&"
export * from "./BornTodayUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
installComponents(component, {VContainer,VLayout,VList})
